import * as Oidc from 'oidc-client';
import { IEnvironmentConfiguration } from 'src/app/models/shared/environment-configuration.interface';

export const environment: IEnvironmentConfiguration = {
  production: false,
  apiVersion: '1.0',
  siteKey: '6LcKEsQUAAAAAInMvymgMFtsX1AAriDs14bUCcYG',
  useCallbackFlag: null,
  origin: 'test-my.heartstylesapp.com',
  authSettings: {
    authLogger: {
      level: Oidc.Log.DEBUG,
      logger: console
    },
    authority: 'https://identitytest.heartstylesapp.com',
    client_id: '08387b67-3a85-403c-8eec-19ed4854fd10',
    response_type: 'id_token token',
    scope: 'openid profile roles Heartstyles.Api',
    redirect_uri: 'https://test-my.heartstylesapp.com/callback.html',
    post_logout_redirect_uri: 'https://test-my.heartstylesapp.com/signout-callback.html',
    silent_redirect_uri: 'https://test-my.heartstylesapp.com/renew-callback.html',
    automaticSilentRenew: true
  },
  apiConfig: {
    activateApi: '/identity/activate',
    antiForgeryTokenApi: '/system/antiforgerytoken',
    baseUrl: 'https://test-peapi.heartstylesapp.com/api',
    checkEmailAddressApi: '/identity/isemailaddressvalid',
    checkEmailAddressProfileApi: '/profile/isemailaddressvalid',
    communicationsApi: '/communications',
    demographicsApi: '/demographics',
    downloadApi: '/download',
    hubApi: '/hubs/usernotificationhub',
    languagesApi: '/system/getsupportedlanguages',
    questionResponseApi: '/surveyquestionresponses',
    questionsApi: '/questions',
    profileApi: '/profile',
    registerApi: '/identity/register',
    reportsApi: '/reports',
    reportsOnlineApi: '/reports/personaledition',
    reportsRequestTokenApi: '/reports/getreportrequesttoken',
    resendRegistrationValidationEmailApi: '/identity/resendregistrationvalidationemail',
    resolveTokenApi: '/identity/resolvetoken',
    responseApi: '/surveyresponses',
    resultsApi: '/results',
    settingsApi: '/settings',
    surveysApi: '/surveys',
    userDemographicsApi: '/userdemographicvalues',
    teamEnquiryApi: '/enquiry',
    webClient: 'https://test.heartstylesapp.com',
    intercomId: 'm7san35s'
  },
  retryConfig: {
    initialInterval: 1000,
    maxRetries: 5
  }};
